/*
 *
 * User reducer
 *
 */

import { LOG_OUT } from 'containers/App/constants';
import { FETCH_USER, FETCH_USER_FAILED, FETCH_USER_SUCCESS } from './constants';

export const initialState = {
  isFetching: false,
  hasFetched: false,
  hasFetchedWithError: false,
  userDetails: false,
  error: false,
};

function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER:
      return Object.assign({}, state, {
        isFetching: true,
        error: false,
      });
    case FETCH_USER_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        userDetails: action.userDetails || false,
        hasFetched: true,
        error: false,
      });
    case FETCH_USER_FAILED:
    case LOG_OUT:
      return Object.assign({}, state, {
        isFetching: false,
        userDetails: false,
        hasFetched: true,
        hasFetchedWithError: true,
        error: action.error || false,
      });
    default:
      return state;
  }
}

export default userReducer;
